<template>
  <!-- 反馈弹窗 -->
  <transition name="fade" mode="out-in">
    <div class="popup feedback-popup" v-show="visible">
      <div class="popup-mask" @click="closePopup"></div>
      <div class="popup-content">
        <div class="popup-content-close" @click="closePopup"></div>
        <div class="popup-title">
          <div class="popup-title-icon"></div>
          <div class="popup-title-text">{{ langData.feedbackPopupTitle }}</div>
        </div>
        <div class="content-area">
          <!-- 目前帳號 -->
          <div class="form-item">
            <label class="form-label">{{ langData.feedbackAccount }}</label>
            <div class="account-info">{{ currentAccount }}</div>
          </div>

          <!-- 電子郵箱 -->
          <div class="form-item">
            <label class="form-label required">{{ langData.feedbackEmail }}</label>
            <input
              class="form-input"
              type="email"
              v-model="formData.email"
              :placeholder="langData.feedbackEmailPlaceholder"
              required
            />
          </div>

          <!-- 伺服器 -->
          <!-- <div class="form-item">
            <label class="form-label required">伺服器：</label>
            <div class="select-box">
              <select
                v-model="formData.server"
                required
                @change="onServerChange"
              >
                <option value="" disabled hidden>請選擇服務器</option>
                <optgroup
                  v-if="
                    serverList.recent_servers &&
                    serverList.recent_servers.length > 0
                  "
                  label="你的伺服器"
                >
                  <option
                    v-for="server in serverList.recent_servers"
                    :key="server.sid"
                    :value="server.sid"
                  >
                    {{ server.sname }}
                  </option>
                </optgroup>
                <optgroup
                  v-if="
                    serverList.all_servers && serverList.all_servers.length > 0
                  "
                  label="所有伺服器"
                >
                  <option
                    v-for="server in serverList.all_servers"
                    :key="server.sid"
                    :value="server.sid"
                  >
                    {{ server.sname }}
                  </option>
                </optgroup>
              </select>
            </div>
          </div> -->

          <!-- 遊戲角色 -->
          <!-- <div class="form-item">
            <label class="form-label">遊戲角色：</label>
            <div class="select-box">
              <select v-model="formData.character" @change="onRoleChange">
                <option value="" disabled hidden>請選擇遊戲角色</option>
                <option
                  v-for="role in roleList"
                  :key="role.roleId"
                  :value="role.roleId"
                >
                  {{ role.roleName }}
                </option>
              </select>
            </div>
          </div> -->

          <!-- 意見類別 -->
          <div class="form-item">
            <label class="form-label required">{{ langData.feedbackCategory }}</label>
            <div class="select-box">
              <select v-model="formData.category" required>
                <option value="" disabled hidden>{{ langData.feedbackCategoryPlaceholder }}</option>
                <option value="1">{{ langData.feedbackCat1 }}</option>
                <option value="2">{{ langData.feedbackCat2 }}</option>
                <option value="3">{{ langData.feedbackCat3 }}</option>
                <option value="4">{{ langData.feedbackCat4 }}</option>
              </select>
            </div>
          </div>

          <!-- 意見回饋內容 -->
          <div class="form-item form-item-vertical">
            <label class="form-label required">{{ langData.feedbackContent }}</label>
            <textarea
              class="text-input"
              v-model="formData.content"
              :placeholder="langData.feedbackContentPlaceholder"
              maxlength="999"
              required
            ></textarea>
            <div class="char-count">{{ formData.content.length }}/999</div>
          </div>

          <!-- 附件上传 -->
          <div class="image-upload-area">
            <div class="upload-title">
              {{ langData.feedbackAttachment }}
              <span class="upload-title-text">
                ({{ attachmentImages.filter((image) => image.url).length }}/3)
                {{ langData.feedbackAttachmentLimit }}
              </span>
            </div>
            <div class="image-list">
              <template v-for="(img, index) in attachmentImages" :key="index">
                <div
                  class="add-image-box"
                  @click="openImageUpload(index)"
                  v-if="img.url === ''"
                >
                  <div class="add-icon">+</div>
                  <div class="add-text">{{ langData.feedbackAddAttachment }}</div>
                </div>
                <div class="view-image-box" v-else>
                  <div
                    class="image-item"
                    :style="{ backgroundImage: `url(${img.url})` }"
                    draggable="true"
                    @dragstart="dragStart(index, $event)"
                    @dragover.prevent
                    @dragenter.prevent
                    @drop="onDrop(index, $event)"
                    @click="viewImage(img.url, '反饋彈窗')"
                  ></div>
                  <div
                    class="remove-btn"
                    @click.stop="removeImage(index)"
                    title="點擊移除圖片"
                  ></div>
                </div>
              </template>
            </div>
            <input
              type="file"
              ref="fileInput"
              style="display: none"
              accept="image/jpeg,image/png,image/jpg,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              @change="handleImageChange"
            />
          </div>
        </div>

        <div class="popup-bottom">
          <div
            class="confirm-btn btns"
            @click="submitFeedback"
            :class="{ disabled: uploadSpinning }"
          >{{ langData.submitBtn }}</div>
          <div
            class="cancel-btn btns"
            @click="closePopup"
            :class="{ disabled: uploadSpinning }"
          >{{ langData.cancelBtn }}</div>
        </div>
      </div>
    </div>
  </transition>

  <!-- 退出确认弹窗 -->
  <exitConfirmPopup
    :visible="showExitConfirm"
    @update:visible="showExitConfirm = $event"
    @confirm="handleExitConfirm"
  />
</template>

<script setup>
import { ref, reactive, watch, inject, computed } from "vue";
import { getJSON } from "@api/request";
import { getUrlParams, getActivityApi } from "@utils";
import LanguageHook from "@hooks/language";
import exitConfirmPopup from "./exitConfirmPopup.vue";

const initActivity = inject("initActivity");

// 定义 props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  userInfo: {
    type: Object,
    default: () => ({}),
  },
});

// 定义 emits
const emit = defineEmits(["update:visible", "showTip", "finish"]);

// 语言相关
const { langData } = LanguageHook();
// 响应式数据
const currentUploadIndex = ref(0);
const draggedIndex = ref(-1);
const fileInput = ref(null);

const formData = reactive({
  email: "",
  server: "",
  character: "",
  characterName: "", // 添加角色名称
  category: "",
  content: "",
  attachments: [],
});

const attachmentImages = reactive([
  { url: "", file: null },
  { url: "", file: null },
  { url: "", file: null },
]);
const uploadSpinning = ref(false);
const showExitConfirm = ref(false);

const reset = () => {
  formData.email = "";
  formData.server = "";
  formData.character = "";
  formData.characterName = "";
  formData.category = "";
  formData.content = "";
  // 清空附件
  attachmentImages.forEach((img, index) => {
    img.url = "";
    img.file = null;
  });
};
// 新增的响应式数据
const serverList = ref({
  all_servers: [],
  recent_servers: [],
});
const roleList = ref([]);

const currentAccount = computed(() => {
  if (props.userInfo && props.userInfo.username) {
    return `${props.userInfo.username || ""}`;
  }
  return langData.notLoggedIn;
});
// 监听弹窗显示状态，当显示时自动请求服务器列表
watch(
  () => props.visible,
  (newVisible) => {
    if (newVisible) {
      listServerNew();
    }
  }
);

// 方法
const closePopup = () => {
  showExitConfirm.value = true;
};

// 确认退出处理
const handleExitConfirm = () => {
  reset();
  emit("update:visible", false);
};

const openImageUpload = (index) => {
  currentUploadIndex.value = index;
  fileInput.value.click();
};

// 服务器选择变化时的处理
const onServerChange = () => {
  // 清空角色列表
  roleList.value = [];
  // 清空角色输入框
  formData.character = "";
  formData.characterName = "";
  // 如果选择了服务器，获取角色列表
  if (formData.server) {
    getMobileGameRole(formData.server);
  }
};

// 角色选择变化时的处理
const onRoleChange = () => {
  if (formData.character) {
    const selectedRole = roleList.value.find(
      (role) => role.roleId === formData.character
    );
    formData.characterName = selectedRole ? selectedRole.roleName : "";
  } else {
    formData.characterName = "";
  }
};

// 文件上传相关函数
const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB

const slice = (file, piece = CHUNK_SIZE) => {
  const totalSize = file.size;
  let start = 0;
  let end = start + piece;
  const chunks = [];
  while (start < totalSize) {
    const blob = file.slice(start, end);
    chunks.push(blob);
    start = end;
    end = start + piece;
  }
  return chunks;
};

const xhrPut = (url, file) => {
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.open("PUT", url);
    xhr.setRequestHeader("Content-Type", "application/octet-stream");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          resolve(xhr.responseText);
        } else {
          reject(xhr.responseText);
        }
      }
    };
    xhr.send(file);
  });
};

const setUploadTaskArr = async (urlList, chunks) => {
  const uploadTaskArr = [];
  for (let i = 0; i < chunks.length; i++) {
    uploadTaskArr.push(xhrPut(urlList[i], chunks[i]));
  }
  await Promise.all(uploadTaskArr);
};

const beforeUpload = async (file) => {
  try {
    const chunks = slice(file);
    // 请求分片上传任务
    const { data, result, code } = await getJSON(
      getActivityApi(window.platform_id, window.activity_name, "upload"),
      {
        params: JSON.stringify({
          slice: chunks.length,
          picType: `.${file.type.split("/")[1]}`, // 文件后缀，如.jpg/.png
        }),
      }
    );
    if (+result === 1) {
      // 分片上传任务设置并运行
      await setUploadTaskArr(data.urls, chunks);
      // 完成分片上传任务
      const res = await getJSON(
        getActivityApi(window.platform_id, window.activity_name, "complete"),
        {
          params: JSON.stringify({
            uploadId: data?.uploadId || "",
          }),
        }
      );
      if (+res?.result === 1) {
        return res?.data?.url || "";
      } else {
        const errorMsg = `[${res?.code}]${
          langData[Math.abs(+res?.code)] || langData.commonTip
        }`;
        console.error("完成上传失败:", errorMsg);
        throw new Error(errorMsg);
      }
    } else {
      const errorMsg = `[${code}]${
        langData[Math.abs(+code)] || langData.commonTip
      }`;
      console.error("初始化上传失败:", errorMsg);
      throw new Error(errorMsg);
    }
  } catch (error) {
    console.error("上传文件异常:", error);
    throw error; // 重新抛出错误，让调用方处理
  }
};

const handleImageChange = async (event) => {
  const file = event.target.files[0];
  if (file) {
    // 检查文件大小（10MB）
    if (file.size > 10 * 1024 * 1024) {
      emit("showTip", langData.feedbackErrFileSize);
      event.target.value = "";
      return;
    }

    // 检查文件类型
    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    if (!allowedTypes.includes(file.type)) {
      emit("showTip", langData.feedbackErrFileType);
      event.target.value = "";
      return;
    }

    // 显示预览
    const reader = new FileReader();
    reader.onload = (e) => {
      attachmentImages[currentUploadIndex.value].url = e.target.result;
    };
    reader.readAsDataURL(file);

    // 保存文件对象
    attachmentImages[currentUploadIndex.value].file = file;
  }
  // 清空 input 值，允许重复选择同一文件
  event.target.value = "";
};

const removeImage = (index) => {
  attachmentImages[index].url = "";
  attachmentImages[index].file = null;
  console.log(`已移除第${index + 1}张图片`);
};

const dragStart = (index, event) => {
  draggedIndex.value = index;
  event.dataTransfer.effectAllowed = "move";
};

const onDrop = (targetIndex, event) => {
  event.preventDefault();
  if (draggedIndex.value !== -1 && draggedIndex.value !== targetIndex) {
    // 交换两个图片的位置
    const draggedImage = attachmentImages[draggedIndex.value];
    const targetImage = attachmentImages[targetIndex];

    attachmentImages[draggedIndex.value] = targetImage;
    attachmentImages[targetIndex] = draggedImage;
  }
  draggedIndex.value = -1;
};

const viewImage = (url, title) => {
  // 这里可以实现图片预览功能
  console.log("查看图片:", url, title);
};

// 获取服务器列表
const listServerNew = async () => {
  try {
    const { data, result, code } = await getJSON(
      getActivityApi(window.platform_id, window.activity_name, "listServerNew")
    );
    if (+result === 1 && data) {
      serverList.value = {
        all_servers: data.all_servers || [],
        recent_servers: data.recent_servers || [],
      };
      console.log("服务器列表:", data);
    } else {
      console.error("获取服务器列表失败:", code);
      serverList.value = {
        all_servers: [],
        recent_servers: [],
      };
    }
  } catch (error) {
    console.error("获取服务器列表异常:", error);
    serverList.value = {
      all_servers: [],
      recent_servers: [],
    };
  }
};

// 获取角色列表
const getMobileGameRole = async (serverId) => {
  if (!serverId) {
    roleList.value = [];
    return;
  }

  try {
    const { data, result, code } = await getJSON(
      getActivityApi(
        window.platform_id,
        window.activity_name,
        "getMobileGameRole"
      ),
      {
        params: JSON.stringify({
          server_id: serverId,
        }),
      }
    );
    if (+result === 1 && data) {
      // 确保 data 是数组，如果是单个对象则转换为数组
      roleList.value = Array.isArray(data) ? data : [data];

      // 如果只有一个角色选项，自动选中
      if (roleList.value.length === 1) {
        formData.character = roleList.value[0].roleId;
        formData.characterName = roleList.value[0].roleName;
      }
    } else {
      roleList.value = [];
    }
  } catch (error) {
    roleList.value = [];
  }
};

const submitFeedback = async () => {
  // 驗證必填項
  if (!formData.email) {
    emit("showTip", langData.feedbackErrEmail);
    return;
  }
  if (!formData.category) {
    emit("showTip", langData.feedbackErrCategory);
    return;
  }
  if (!formData.content) {
    emit("showTip", langData.feedbackErrContent);
    return;
  }

  try {
    window.activityDataLayer.push({
      eventName: "click_button",
      eventType: "意見回饋提交",
      eventReason: "意見回饋提交",
    });
    // 显示加载中
    uploadSpinning.value = true;

    // 上传附件文件并获取URL
    const attachmentUrls = [];
    const totalFiles = attachmentImages.filter((img) => img.file).length;
    let uploadedCount = 0;

    for (let i = 0; i < attachmentImages.length; i++) {
      const attachment = attachmentImages[i];
      if (attachment.file) {
        try {
          const uploadedUrl = await beforeUpload(attachment.file);
          if (uploadedUrl) {
            attachmentUrls.push(uploadedUrl);
            uploadedCount++;
            console.log(`第${uploadedCount}张图片上传成功:`, uploadedUrl);
          } else {
            console.error(`attachment ${i + 1} upload failed: no valid URL`);
            emit("showTip", langData.commonTip);
            return; // 如果有图片上传失败，终止提交
          }
        } catch (error) {
          console.error(`attachment ${i + 1} upload error:`, error);
          emit("showTip", langData.commonTip);
          return; // 如果有图片上传异常，终止提交
        }
      }
    }

    // 準備提交數據，按照API要求的格式
    const params = {
      email: formData.email,
      sId: formData.server,
      roleId: formData.character || "", // 角色ID，可以為空
      roleName: encodeURIComponent(encodeURIComponent(formData.characterName || "")), // 角色名称，可以为空
      attachUrlList: attachmentUrls.join(","), // 附件URL列表，逗号分隔
      feedbackContent: encodeURIComponent(formData.content),
      feedbackType: formData.category, // 1-4的数字
    };

    // 调用反馈API
    const { data, result, code } = await getJSON(
      getActivityApi(window.platform_id, window.activity_name, "feedback"),
      {
        params: JSON.stringify(params),
      }
    );

    if (+result === 1) {
      // 清空表单
      reset();
      await initActivity();
      emit("finish");
    } else {
      emit(
        "showTip",
        `[${code}]${
          langData[Math.abs(+code)] || data?.message || langData.commonTip
        }`
      );
    }
  } catch (error) {
    console.error("提交反饋異常:", error);
  } finally {
    uploadSpinning.value = false;
  }
};
</script>
